module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MQ-1449e6fb9d9cbfe82a3a7f87a77d5aca.png";